import { TrashIcon } from '@heroicons/react/24/outline';
import { CollaboratorCombobox } from '@/components/shared';
import type { CollaboratorPublic } from '@/features/Collaborators/Data';
import type { Equipamento } from '../../../models';
import BuscaAtivoInventario from '../../../components/BuscaAtivoInventario';

export interface LinhaEquipamentoState {
  id: string;
  patrimonio: string;
  nSerie: string;
  modelo: string;
  colaboradorCotado: CollaboratorPublic | null;
  /** Ativo do Inventário achado pela busca — só linhas com ativo entram no envio. */
  ativo: Equipamento | null;
}

interface LinhaEnviarEquipamentoProps {
  linha: LinhaEquipamentoState;
  onChange: (linha: LinhaEquipamentoState) => void;
  onRemover?: () => void;
}

/**
 * Uma linha de equipamento em "Enviar para Cliente" — mesma busca no Inventário do vínculo
 * da Movimentação (BuscaAtivoInventario): o inventário todo está no Digital, então só vai o
 * que existe lá ("cadastrar agora?" quando não acha).
 */
export default function LinhaEnviarEquipamento({ linha, onChange, onRemover }: LinhaEnviarEquipamentoProps) {
  return (
    <div className="space-y-2 rounded-md border border-gray-200 p-3">
      <div className="flex items-start justify-between">
        <p className="text-xs font-medium uppercase text-gray-400">Equipamento</p>
        {onRemover && (
          <button type="button" className="text-gray-400 hover:text-red-600" onClick={onRemover} title="Remover">
            <TrashIcon className="h-4 w-4" />
          </button>
        )}
      </div>

      <BuscaAtivoInventario
        valor={{ patrimonio: linha.patrimonio, nSerie: linha.nSerie, encontrado: linha.ativo }}
        onChange={(valor) =>
          onChange({
            ...linha,
            patrimonio: valor.patrimonio,
            nSerie: valor.nSerie,
            ativo: valor.encontrado,
            modelo: valor.encontrado?.modelo ?? linha.modelo,
          })
        }
        paraEnvio
        cadastroInicial={{ modelo: linha.modelo }}
      />

      <div>
        <label className="block text-xs font-medium text-gray-500">
          Colaborador cotado (opcional — só um plano, pode trocar depois)
        </label>
        <CollaboratorCombobox
          selectedId={linha.colaboradorCotado?.id ?? null}
          onChange={(colaborador) => onChange({ ...linha, colaboradorCotado: colaborador })}
          placeholder="Buscar colaborador..."
        />
      </div>
    </div>
  );
}
